<div class="dialog-header">
  <h6 matDialogTitle>{{ privacyHeader }}</h6>
  <button class="close-button" tabindex="-1" (click)="close(false)">
    <mat-icon
      role="img"
      fonticon="bosch-ic-close"
      class="mat-icon notranslate bosch-ic-close Bosch-Ic mat-icon-no-color"
      aria-hidden="true"
      data-mat-icon-type="font"
      data-mat-icon-name="bosch-ic-close"
    ></mat-icon>
  </button>
</div>
<mat-divider></mat-divider>
<mat-dialog-content>
  <div style="height: 100px" [innerHTML]="privacyMessage"></div>
</mat-dialog-content>
